var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavAdAccounts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.79 2.52q.21-.04.42 0c.166.03.313.107.373.138l.016.008 6.457 3.246a.808.808 0 0 1 0 1.445l-6.457 3.245-.016.008c-.06.031-.207.107-.373.139a1.1 1.1 0 0 1-.42 0c-.166-.032-.313-.108-.374-.139l-.015-.008-6.457-3.245a.808.808 0 0 1 0-1.445l6.457-3.246.016-.008c.06-.031.207-.107.373-.138"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.585 9.639a.8.8 0 0 1 1.078-.362L10 12.463l6.337-3.186a.8.8 0 0 1 1.078.362.81.81 0 0 1-.36 1.084L10.6 13.968l-.016.008c-.06.031-.207.107-.373.138a1.1 1.1 0 0 1-.42 0 1.4 1.4 0 0 1-.373-.138l-.016-.008-6.457-3.245a.81.81 0 0 1-.359-1.084"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.585 13.005a.8.8 0 0 1 1.078-.362L10 15.83l6.337-3.186a.8.8 0 0 1 1.078.362.81.81 0 0 1-.36 1.083L10.6 17.335l-.016.008c-.06.031-.207.107-.373.138a1.1 1.1 0 0 1-.42 0 1.4 1.4 0 0 1-.373-.138l-.016-.008-6.457-3.245a.81.81 0 0 1-.359-1.084"
})));
SvgNavAdAccounts.displayName = "SvgNavAdAccounts";
export { SvgNavAdAccounts as ReactComponent };
export default SvgNavAdAccounts;